import { useState } from 'react';
import { toAmendmentScope } from '~/components/ai/BulkAmendmentAgentPane/utils/amendmentScope';
import { relationshipSummaryModel } from '~/models';
import { useIoContext } from '~/providers/IoContext';
import { isUserDrivenNarrowing } from '../AgreementsAiSearch/hooks/agreementFilterActivity';
import { useAgreementsAiSearchStore } from '../AgreementsAiSearch/hooks/useAgreementsAiSearchStore';
import { deriveActiveFilterText, isAgreementSearchFilterShape, readAmendmentPaneOpenFromLocationState, selectedRowsFromAgreementIds } from '../AgreementsDashboard.utils';
export const useBulkAmendmentAgentPane = (param)=>{
    let { agreements, selected, setSelected, selectedAgreementIds, aiSearchScope, isVendor, refreshLanes } = param;
    const { browser: { persistLocationState, readPersistedLocationState } } = useIoContext();
    // eslint-disable-next-line no-restricted-syntax -- WHY: a collapsible pane, not a modal; open state is persisted to history state and restored on mount, same as the drafts pane
    const [isOpen, setIsOpen] = useState(()=>readAmendmentPaneOpenFromLocationState(readPersistedLocationState()));
    const setOpen = (open)=>{
        setIsOpen(open);
        persistLocationState({
            amendmentPaneOpen: open
        });
    };
    return {
        open: ()=>setOpen(true),
        paneProps: {
            // WHY: the chip row seeds a display-default filter on mount, so only a filter that is actually narrowing the table describes a scope the seller chose.
            scope: toAmendmentScope({
                currentFilter: aiSearchScope.isNarrowingTable ? aiSearchScope.filter : null,
                selectedAgreementIds,
                totalMatchCount: aiSearchScope.isNarrowingTable ? aiSearchScope.totalMatchCount : agreements.length,
                activeFilterText: aiSearchScope.isNarrowingTable ? deriveActiveFilterText(aiSearchScope.lastQuery, aiSearchScope.filterEdited) : ''
            }),
            agreementNames: agreements.filter((agreement)=>selected[agreement.id] === true).map((agreement)=>{
                var _relationshipSummaryModel_displayedTitle;
                return (_relationshipSummaryModel_displayedTitle = relationshipSummaryModel.displayedTitle(agreement, isVendor)) !== null && _relationshipSummaryModel_displayedTitle !== void 0 ? _relationshipSummaryModel_displayedTitle : '';
            }).filter((name)=>name.length > 0),
            // WHY: an empty query means the replayed turn carried no prompt text (a document upload); setFilter would leave the filter showing in the chips but never applied to the table, so editFilter marks it user-driven instead.
            onFilterUpdate: (filter, query)=>query.length > 0 ? useAgreementsAiSearchStore.getState().setFilter(filter, query) : useAgreementsAiSearchStore.getState().editFilter(filter),
            onSelectionUpdate: (ids)=>setSelected(selectedRowsFromAgreementIds(ids)),
            onScopeRestore: (restored)=>{
                // WHY: editFilter — not setFilter — because the results lane only runs for a user-driven filter, and setFilter's empty query would leave the restored scope showing in the chips but never applied to the table.
                // WHY: read the store at call time — this callback runs in the recent() .then, so a prop captured at render cannot see a narrowing the seller performed while the request was in flight.
                const tableAlreadyNarrowed = isUserDrivenNarrowing(useAgreementsAiSearchStore.getState());
                if (!tableAlreadyNarrowed && isAgreementSearchFilterShape(restored.currentFilter)) {
                    useAgreementsAiSearchStore.getState().editFilter(restored.currentFilter);
                }
                if (selectedAgreementIds.length === 0 && restored.selectedAgreementIds != null) {
                    setSelected(selectedRowsFromAgreementIds(restored.selectedAgreementIds));
                }
            },
            onAgreementsChanged: refreshLanes,
            isOpen,
            onOpenChange: setOpen
        }
    };
};
